import React from 'react';
import { Flex, Text } from '@vibe/core';
import { TimesheetStatusBadge } from './TimesheetStatusBadge';
import type { TimesheetSubmission } from '../../types/timesheet-approval.types';
import { formatHoursMinutes } from '../../utils/timesheet-capacity';

export interface TimesheetStatusBannerProps {
  submission: TimesheetSubmission | null;
  approverName?: string;
}

/**
 * Status banner displayed above the timesheet grid.
 * Shows the current submission status, approver name, and rejection/reopen reasons.
 */
const TimesheetStatusBanner: React.FC<TimesheetStatusBannerProps> = ({
  submission,
  approverName,
}) => {
  if (!submission) return null;

  return (
    <div className="rp-ts-approval-banner">
      <Flex gap={Flex.gaps.SMALL} align={Flex.align.CENTER}>
        <TimesheetStatusBadge status={submission.status} />

        {approverName && (
          <Text type={Text.types.TEXT2} color={Text.colors.SECONDARY}>
            Approver: {approverName}
          </Text>
        )}

        {submission.totalHours > 0 && (
          <Text type={Text.types.TEXT2} color={Text.colors.SECONDARY}>
            {formatHoursMinutes(submission.totalHours)} ({submission.worklogCount} entries)
          </Text>
        )}
      </Flex>

      {submission.status === 'rejected' && submission.rejectionReason && (
        <div className="rp-ts-approval-banner__reason">
          <Text type={Text.types.TEXT2} style={{ color: '#e2445c' }}>
            Rejection reason: {submission.rejectionReason}
          </Text>
        </div>
      )}

      {submission.status === 'reopened' && (
        <div className="rp-ts-approval-banner__reason">
          <Text type={Text.types.TEXT2} style={{ color: '#676879' }}>
            This timesheet was reopened. Please review and resubmit.
          </Text>
        </div>
      )}
    </div>
  );
};

export default TimesheetStatusBanner;
